import { memo } from 'react'
import { observer } from 'mobx-react'

import CreateFinalAfterInactivity from './components/CreateFinalAfterInactivity'
import { InactivityType } from './InactivityContainer.types'
import {
  determineInactivityTimeout,
  TIMEOUT_FIVE_MINUTES
} from './helpers/determineInactivityTimeout'
import useUserState from 'hooks/useUserState'
import { useGate } from 'gates'

type InactivityProps = {
  handleSubmit: () => void
  isSmava?: boolean
}

const InactivityContainer = observer(
  ({ handleSubmit, isSmava }: InactivityProps) => {
    const { debtorsAge, isMiddleAge, isPremium } = useUserState()
    const isCat4784Experiment = useGate('cat4784SmavaStandardDacExperiment')

    const timeout = determineInactivityTimeout(
      debtorsAge,
      isSmava || false,
      isCat4784Experiment && isMiddleAge && !isPremium
    )

    if (!timeout) {
      return null
    }

    return (
      <>
        <CreateFinalAfterInactivity
          timeout={TIMEOUT_FIVE_MINUTES}
          inactivityType={InactivityType.PAYOUT_ACCOUNT_INACTIVITY}
          onNext={handleSubmit}
        />
        <CreateFinalAfterInactivity
          timeout={timeout}
          inactivityType={InactivityType.DAC_INACTIVITY}
          onNext={handleSubmit}
        />
      </>
    )
  }
)

export default memo(InactivityContainer)
